export default __webpack_public_path__ + "static/media/DecDom2023.9d07267a.png";